import { createStructuredSelector } from "reselect";
import {
    HR_PRODUCT,
    HR_PRODUCT_SUCCESS,
    HR_PRODUCT_ERROR,
    HR_PRODUCT_LIST,
    HR_PRODUCT_LIST_SUCCESS,
    HR_PRODUCT_LIST_ERROR,
    HR_SUPPLIER,
    HR_SUPPLIER_SUCCESS,
    HR_SUPPLIER_ERROR,
    HR_CATEGORY,
    HR_CATEGORY_SUCCESS,
    HR_CATEGORY_ERROR,
    HR_COUNTRY,
    HR_COUNTRY_SUCCESS,
    HR_COUNTRY_ERROR,
    HR_STATUS,
    HR_STATUS_SUCCESS,
    HR_STATUS_ERROR,
    HR_LIST,
    HR_LIST_SUCCESS,
    HR_LIST_ERROR,
    HR_LIST_SEARCH_CHANGE,
    HR_LIST_PAGE_SET,
    HR_ADD_MODAL_SET,
    HR_ADD_CHANGE_SET,
    HR_ADD,
    HR_ADD_SUCCESS,
    HR_ADD_ERROR,
    HR_EDIT_MODAL_SET,
    HR_EDIT_CHANGE_SET,
    HR_EDIT,
    HR_EDIT_SUCCESS,
    HR_EDIT_ERROR,
    HR_UPLOAD_SET,
    HR_UPLOAD_SET_SUCCESS,
    HR_UPLOAD_SET_ERROR,
    HR_UPLOAD_RESET
} from "../../actions";

export const NAME = 'healthRegistration';

export const HRProduct = (data) => ({
    type: HR_PRODUCT,
    payload: data
});

export const HRProductSuccess = (data) => ({
    type: HR_PRODUCT_SUCCESS,
    payload: data
});

export const HRProductError = (error) => ({
    type: HR_PRODUCT_ERROR,
    payload: error
});

export const HRProductList = (data) => ({
    type: HR_PRODUCT_LIST,
    payload: data
});

export const HRProductListSuccess = (data) => ({
    type: HR_PRODUCT_LIST_SUCCESS,
    payload: data
});

export const HRProductListError = (error) => ({
    type: HR_PRODUCT_LIST_ERROR,
    payload: error
});

export const HRSupplier = (data) => ({
    type: HR_SUPPLIER,
    payload: data
});

export const HRSupplierSuccess = (data) => ({
    type: HR_SUPPLIER_SUCCESS,
    payload: data
});

export const HRSupplierError = (error) => ({
    type: HR_SUPPLIER_ERROR,
    payload: error
});

export const HRCategory = (data) => ({
    type: HR_CATEGORY,
    payload: data
});

export const HRCategorySuccess = (data) => ({
    type: HR_CATEGORY_SUCCESS,
    payload: data
});

export const HRCategoryError = (error) => ({
    type: HR_CATEGORY_ERROR,
    payload: error
});

export const HRCountry = (data) => ({
    type: HR_COUNTRY,
    payload: data
});

export const HRCountrySuccess = (data) => ({
    type: HR_COUNTRY_SUCCESS,
    payload: data
});

export const HRCountryError = (error) => ({
    type: HR_COUNTRY_ERROR,
    payload: error
});

export const HRStatus = (data) => ({
    type: HR_STATUS,
    payload: data
});

export const HRStatusSuccess = (data) => ({
    type: HR_STATUS_SUCCESS,
    payload: data
});

export const HRStatusError = (error) => ({
    type: HR_STATUS_ERROR,
    payload: error
});


export const HRList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: HR_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const HRListSuccess = (data) => ({
    type: HR_LIST_SUCCESS,
    payload: data
});

export const HRListError = (error) => ({
    type: HR_LIST_ERROR,
    payload: error
});

export const HRPageSet = (data) => ({
    type: HR_LIST_PAGE_SET,
    payload: data
});

export const HRSearchChange = (data) => ({
    type: HR_LIST_SEARCH_CHANGE,
    payload: data
});

export const HRAddModalSet = (data) => ({
    type: HR_ADD_MODAL_SET,
    payload: data
});

export const HRAddChangeSet = (data) => ({
    type: HR_ADD_CHANGE_SET,
    payload: data
});

export const HRAdd = (page, num_page, orderBy, filters, data) => ({
    type: HR_ADD,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const HRAddSuccess = (message) => ({
    type: HR_ADD_SUCCESS,
    payload: message
});

export const HRAddError = (error) => ({
    type: HR_ADD_ERROR,
    payload: error
});


export const HREditModalSet = (data) => ({
    type: HR_EDIT_MODAL_SET,
    payload: data
});

export const HREditChangeSet = (data) => ({
    type: HR_EDIT_CHANGE_SET,
    payload: data
});

export const HREdit = (page, num_page, orderBy, filters, data) => ({
    type: HR_EDIT,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const HREditSuccess = (message) => ({
    type: HR_EDIT_SUCCESS,
    payload: message
});

export const HREditError = (error) => ({
    type: HR_EDIT_ERROR,
    payload: error
});

export const HRUploadSet = (file) => ({
    type: HR_UPLOAD_SET,
    payload: { file },
});

export const HRUploadSetSuccess = (items) => ({
    type: HR_UPLOAD_SET_SUCCESS,
    payload: items,
});

export const HRUploadSetError = (error) => ({
    type: HR_UPLOAD_SET_ERROR,
    payload: error,
});

export const HRUploadReset = () => ({
    type: HR_UPLOAD_RESET
});

const healthRegistration = (state) => state[NAME];

export const HealthRegistrationSelector = createStructuredSelector({
    healthRegistration
})